import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuEmployeesComponent } from './menu-employees/menu-employees.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { MensajeComponent } from './mensaje/mensaje.component';
import { ModalObligatoriosComponent } from './modal-obligatorios/modal-obligatorios.component';
import { TurnoComponent } from './turno/turno.component';
import { RegistroHorasComponent } from './registro/registro-horas/registro-horas.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { MenuComponent } from './menu/menu.component';
import { TurnoNoInformadoModalComponent } from './turno-no-informado-modal/turno-no-informado-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpenseTypeSelectorComponent } from './gastos/expense-type-selector.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';

@NgModule({
    declarations: [
        MenuComponent,
        MenuEmployeesComponent,
        MensajeComponent,
        ModalObligatoriosComponent,
        TurnoComponent,
        TurnoNoInformadoModalComponent,
        RegistroHorasComponent,
        ExpenseTypeSelectorComponent,
        SignaturePadComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        AngularSignaturePadModule,
    ],
    exports: [
        MenuComponent,
        MenuEmployeesComponent,
        MensajeComponent,
        ModalObligatoriosComponent,
        TurnoComponent,
        TurnoNoInformadoModalComponent,
        RegistroHorasComponent,
        ExpenseTypeSelectorComponent,
        SignaturePadComponent 
    ]
})
export class ComponentesModule { }
